// Mobile nav slide-in panel, ported from the source app's <MobileNav>: opens/closes via
// data attributes, traps scroll while open, closes on Escape or backdrop click.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var nav = document.querySelector('[data-tap-mobile-nav]');
    var openButtons = document.querySelectorAll('[data-tap-mobile-nav-open]');
    var closeButtons = document.querySelectorAll('[data-tap-mobile-nav-close]');
    if (!nav || !openButtons.length) return;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    // Sticky header shadow-on-scroll, ported from the source app's useScrolled hook.
    var header = document.querySelector('[data-tap-header]');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  });
})();
